module.exports = __webpack_public_path__ + "static/media/floor.bf34f704.png";